import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=6cfd22d7&scoped=true"
import script from "./coupon.vue?vue&type=script&lang=js"
export * from "./coupon.vue?vue&type=script&lang=js"
import style0 from "./coupon.vue?vue&type=style&index=0&id=6cfd22d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfd22d7",
  null
  
)

export default component.exports